<template>
  <v-row class="px-4 pt-3 pb-4 details-policy__card pt-9">
    <v-col cols="12">
      <p class="primary--text font-weight-bold mb-3">
        DADOS DE IDENTIFICAÇÃO
      </p>
    </v-col>
    <v-col cols="12" class="mb-3 details-policy__item">
      <v-row class="pa-4">
        <v-col cols="12" sm="6" class="pb-5 pb-sm-0 pr-sm-5">
          <p class="body-2 primary--text mb-0 details-policy__title-height">
            Número da Apólice
          </p>
          <p
            class="body-2 secondary--text mb-0 font-weight-bold details-policy__title-height"
          >
            {{ item.numero }}
          </p>
        </v-col>
        <v-col cols="12" sm="6" class="d-flex justify-sm-end">
          <BaseButton
            color="secondary"
            class="px-0 mr-2 details-policy__button"
            @click="previewPolicy"
            v-if="canSeePolicyDocument"
          >
            <v-icon color="white">
              fa-file
            </v-icon>
          </BaseButton>
          <BaseButton
            v-if="hasBillsPolicy"
            color="secondary"
            class="px-0 details-policy__button"
            @click="$emit('bills')"
          >
            <v-icon color="white">
              fa-barcode
            </v-icon>
          </BaseButton>
        </v-col>
      </v-row>
    </v-col>
    <v-col cols="12" sm="6" class="pb-3 pr-sm-4">
      <v-row class="details-policy__item px-3 py-4">
        <v-col cols="12">
          <p class="subtitle-2 primary--text mb-0 details-policy__title-height">
            Início de vigência:
          </p>
          <p
            class="body-2 font-weight-bold primary--text mb-0 details-policy__title-height"
          >
            DE 24HRS DE {{ formatDateToDDMMYYYY(item.inicio_vigencia) }}
          </p>
        </v-col>
      </v-row>
    </v-col>
    <v-col cols="12" sm="6" class="pb-3">
      <v-row class="details-policy__item px-3 py-4">
        <v-col cols="12">
          <p class="subtitle-2 primary--text mb-0 details-policy__title-height">
            Fim de vigência:
          </p>
          <p
            class="body-2 font-weight-bold primary--text mb-0 details-policy__title-height"
          >
            DE 24HRS DE {{ formatDateToDDMMYYYY(item.fim_vigencia) }}
          </p>
        </v-col>
      </v-row>
    </v-col>
    <v-col cols="12" class="details-policy__item py-3">
      <div :class="classStatus">
        <div class="py-0 px-4">
          <v-row>
            <v-col cols="11" v-if="isRequestedCancel">
              <p
                class="subtitle-2 primary--text mb-0 details-policy__title-height"
              >
                Status:
                <label :class="colorStatus + ' body-2 font-weight-bold'">
                  {{ item.situacao.nome }}
                </label>
                <v-tooltip
                  bottom
                  content-class="tooltip-label-form"
                  v-if="!isCancelPolicy"
                >
                  <template v-slot:activator="{ on }">
                    <img src="@/assets/ic_warning.svg" class="px-1" v-on="on" />
                  </template>
                  <div class="px-4 py-3">
                    <p class="white--text tooltip-label-text mb-0">
                      {{ textTooltip }}
                    </p>
                  </div>
                </v-tooltip>
              </p>
            </v-col>
            <v-col cols="6" v-else>
              <p
                class="subtitle-2 primary--text mb-0 details-policy__title-height"
              >
                Status:
                <label :class="colorStatus + ' body-2 font-weight-bold'">
                  {{ item.situacao.nome }}
                </label>
              </p>
            </v-col>
            <v-col
              cols="6"
              class="d-flex justify-end"
              v-if="showButtonReasonsCancel"
            >
              <BaseButton
                v-html="'Ver motivo >'"
                @click="$emit('open')"
                text
                color="primary"
                style="height: 20px"
                class="px-0"
              />
            </v-col>
          </v-row>
        </div>
      </div>
    </v-col>
  </v-row>
</template>
<script>
import {
  formatDateToDDMMYYYY,
  formatIsoDateToDDMMYYYY
} from "@/utils/formats.js";
import { mapState } from "vuex";
const colorByStatus = [
  { color: "pink", status: "cancelada" },
  { color: "blue", status: "renovada" },
  { color: "success", status: "ativa" },
  { color: "pink", status: "vencida" }
];
const DEFAULT_STATUS = { color: "pink" };
export default {
  data: () => ({
    listColor: colorByStatus,
    defaultStatus: DEFAULT_STATUS,
    formatDateToDDMMYYYY,
    formatIsoDateToDDMMYYYY
  }),
  computed: {
    ...mapState(["userPermissions"]),
    canSeePolicyDocument() {
      return (
        this.userPermissions.acoes.some(
          x => x.id == "visualizar_pdf_apolice"
        ) && this.item.arquivo
      );
    },
    textTooltip() {
      return `Cancelamento solicitado por
        ${this.item.cancelamento_solicitado_por.nome} em
        ${this.formatIsoDateToDDMMYYYY(this.item.cancelamento_solicitado_em)}`;
    },
    colorStatus() {
      return `${this.statusPolicy.color}--text`;
    },
    statusPolicy() {
      return (
        this.listColor.find(x => x.status == this.item.situacao.id) ||
        this.defaultStatus
      );
    },
    classStatus() {
      return `details-policy__border-${this.statusPolicy.color}`;
    },
    isCancelPolicy() {
      return this.item.situacao.id == "cancelada";
    },
    isRequestedCancel() {
      return Boolean(this.item.tem_solicitacao_cancelamento);
    },
    hasBillsPolicy() {
      return (
        this.item.boletos &&
        this.item.boletos.length > 0 &&
        this.userPermissions.acoes.some(
          x => x.id == "visualizar_pdf_boleto_apolice"
        )
      );
    },
    showButtonReasonsCancel() {
      // TODO(Renan): Será desativado por hora para melhor analise
      return false;
    }
  },
  methods: {
    previewPolicy() {
      window.open(this.item.arquivo.url);
    }
  },
  props: {
    item: {
      type: Object
    }
  }
};
</script>
